import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Profile from "./components/Dashboards/ClientDashboard/Profile";
import ClientDashboard from "./components/Dashboards/ClientDashboard";
import Error from "./components/Error";
import InternDashboard from "./components/Dashboards/InternDashboard";
import { AnimatePresence } from "framer-motion";
import EmployeeDashboard from "./components/Dashboards/EmployeeDashboard";
import ForgotPassword from "./components/ForgotPassword";
import AllTickets from "./components/Dashboards/ClientDashboard/AllTickets";
import TicketPage from "./components/Dashboards/TicketPage";
import ClientProfile from "./components/ClientProfile";
import ClientList from "./components/ClientList";
import AddProject from "./components/AddProject";
import AddClientProject from "./components/Dashboards/AdminDashboard/AddClientProject";
import ViewProject from "./components/ViewProject";
import AddProjectUpdate from "./components/Dashboards/AdminDashboard/AddProjectUpdate";
import EmployeeList from "./components/EmployeeList";
import AddEmployee from "./components/Dashboards/AdminDashboard/AddEmployee";
import EmployeeProfile from "./components/EmployeeProfile";
import ProjectTicketsView from "./components/Dashboards/ClientDashboard/ProjectTicketsView";
import TicketDetail from "./components/Dashboards/ClientDashboard/TicketDetail";
import TicketService from "./services/TicketService";
import Projects from "./components/Dashboards/ClientDashboard/Projects";
import AddClient from "./components/Dashboards/AdminDashboard/AddClient";
import ViewBillingItem from "./components/Dashboards/AdminDashboard/billing/ViewBillingItem";
import EditBillingItem from "./components/Dashboards/AdminDashboard/billing/EditBillingItem";
import AdminDashboard from "./components/Dashboards/AdminDashboard";
import BillsManagement from "./components/Dashboards/AdminDashboard/BillsManagement";
import EmployeeTaskDashboard from "./components/Dashboards/AdminDashboard/EmployeeTaskDashboard";
import TaskCalendar from "./components/Dashboards/AdminDashboard/TaskCalendar";
import EmployeeTaskManagement from "./components/Dashboards/AdminDashboard/EmployeeTaskManagement";

const App = () => {
  const { user, logout } = useContext(AuthContext); // This now works because AuthProvider wraps it
  const RedirectToExternal = () => {
    useEffect(() => {
      window.location.href = "https://www.kodekalp.com/";
    }, []);

    return null; // No UI needed
  };

  return (
    <Router>
      <AnimatePresence>
        <Routes>
          <Route path="/na" element={<RedirectToExternal />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<Dashboard />}>
            {user?.role === "CLIENT" && (
              <>
                <Route path="/dashboard" element={<ClientDashboard />} />
                <Route
                  path="/dashboard/ticket"
                  element={<ProjectTicketsView />}
                />
                <Route
                  path="/dashboard/ticket/"
                  element={<ProjectTicketsView />}
                />
                <Route
                  path="/dashboard/ticket/:projectId"
                  element={<ProjectTicketsView />}
                />
                <Route
                  path="/dashboard/tickets/:ticketId"
                  element={<TicketDetail />}
                />
                <Route path="/dashboard/project" element={<Projects />} />
                <Route path="/dashboard/profile" element={<ClientProfile />} />
                <Route
                  path="/dashboard/projects/:projectId"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/:activeTab"
                  element={<ViewProject />}
                />
                

                <Route
                  path="/dashboard/billing-items/:billingItemId"
                  element={<ViewBillingItem />}
                />
              </>
            )}
            {user?.role === "INTERN" && (
              <>
                <Route path="/dashboard" element={<InternDashboard />} />
                <Route path="/dashboard/ticket" element={<TicketPage />} />
                <Route path="/dashboard/profile" element={<Profile />} />
                <Route path="/dashboard/project" element={<Projects />} />
                <Route
                  path="/dashboard/projects/:projectId"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/:activeTab"
                  element={<ViewProject />}
                />
              </>
            )}
            {user?.role === "EMP" && (
              <>
                <Route path="/dashboard" element={<EmployeeDashboard />} />
                <Route path="/dashboard/profile" element={<EmployeeProfile />} />
                <Route path="/dashboard/project" element={<Projects />} />
                <Route
                  path="/dashboard/projects/:projectId"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/:activeTab"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/add-update"
                  element={<AddProjectUpdate />}
                />
              

              </>
            )}
            {user?.role === "ADMIN" && (
              <>
                <Route path="/dashboard" element={<AdminDashboard />} />
                <Route path="/dashboard/client-list" element={<ClientList />} />
                <Route path="/dashboard/client/add" element={<AddClient />} />
                <Route
                  path="/dashboard/client/:clientId"
                  element={<ClientProfile />}
                />
                <Route path="/dashboard/project" element={<Projects />} />
                <Route
                  path="/dashboard/projects/:projectId"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/:activeTab"
                  element={<ViewProject />}
                />
                <Route
                  path="/dashboard/projects/:projectId/add-update"
                  element={<AddProjectUpdate />}
                />
                <Route
                  path="/dashboard/billing-items/:billingItemId"
                  element={<ViewBillingItem />}
                />
                <Route
                  path="/dashboard/billing-items/:billingItemId/edit"
                  element={<EditBillingItem />}
                />
                <Route
                  path="/dashboard/client/add-project"
                  element={<AddProject />}
                />
                <Route
                  path="/dashboard/client/:clientId/add-project"
                  element={<AddClientProject />}
                />
                <Route
                  path="/dashboard/employee-list"
                  element={<EmployeeList />}
                />
                <Route
                  path="/dashboard/employee/add"
                  element={<AddEmployee />}
                />
                <Route
                  path="/dashboard/employee/:employeeId"
                  element={<EmployeeProfile />}
                />
                <Route path="/dashboard/ticket" element={<TicketPage />} />
                <Route path="/dashboard/bills" element={<BillsManagement />} />
                <Route path="/dashboard/profile" element={<Profile />} />

                 <Route path="/dashboard/task" element={<EmployeeTaskDashboard />} />
               <Route path="/dashboard/task-calendar" element={<TaskCalendar />} />
               <Route path="/dashboard/task-management" element={<EmployeeTaskManagement />} />
              </>
            )}
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </Router>
  );
};

const RootApp = () => (
  <AuthProvider>
    {" "}
    {/* Move AuthProvider here to wrap the entire App */}
    <App />
  </AuthProvider>
);

export default RootApp;
